package com.castly.admin.external

/**
 * External declarations for marked.js - a fast markdown parser
 * Documentation: https://marked.js.org/
 */
@JsModule("marked")
@JsNonModule
external object marked {
    /**
     * Parse markdown and return HTML
     */
    fun parse(markdown: String): String

    /**
     * Parse markdown with options
     */
    fun parse(markdown: String, options: MarkedOptions): String
}

external interface MarkedOptions {
    var gfm: Boolean?              // GitHub Flavored Markdown (default: true)
    var breaks: Boolean?            // Line breaks (default: false)
    var headerIds: Boolean?         // Include header IDs (default: true)
    var mangle: Boolean?            // Mangle email addresses (default: true)
}

/**
 * Create marked options with DSL
 */
fun markedOptions(block: MarkedOptions.() -> Unit): MarkedOptions {
    val options = js("{}").unsafeCast<MarkedOptions>()
    options.apply(block)
    return options
}
